import { FormControlLabel, FormControlLabelProps, Radio, RadioProps } from '@mui/material';
import React from 'react';
import { Controller, ControllerRenderProps, UseControllerProps, useFormContext } from 'react-hook-form';

import { SurveyFormKeyEnum } from '~modules/surveys/forms/SurveyForm';

interface ISurveyRadioLabelProps extends Omit<FormControlLabelProps, 'control'> {
  name: string;
  parentName?: string;
  hookFormProps?: Omit<UseControllerProps<any>, 'name' | 'render'>;
  radioProps?: Omit<RadioProps, 'checked' | 'onChange'>;
  happyIndex?: number | null;
}

/**
 * FormControlLabel (Radio) с react-hook-form Controller
 *
 * @param name - для react-hook-form Controller
 * @param radioProps
 * @param hookFormProps
 * @param rest - наследуются от FormControlLabelProps
 */
export const SurveyRadioLabel: React.FC<ISurveyRadioLabelProps> = (props) => {
  const { name, parentName, radioProps, hookFormProps, happyIndex, ...rest } = props;

  const { control, setValue } = useFormContext();

  // Handlers

  const handleChange = (field: ControllerRenderProps) => {
    field.onChange(rest.value);

    if (!parentName || !happyIndex) return;

    setValue(`${parentName}.${SurveyFormKeyEnum.happyIndex}`, happyIndex);
  };

  // Renders

  return (
    <Controller
      name={name}
      render={({ field }) => {
        return (
          <FormControlLabel
            control={
              <Radio
                checked={field.value === rest.value}
                onChange={() => handleChange(field)}
                sx={(theme) => ({
                  color: theme.palette.text.secondary,
                })}
                {...radioProps}
              />
            }
            {...rest}
          />
        );
      }}
      {...hookFormProps}
      control={hookFormProps?.control || control}
    />
  );
};
